import * as React from "react";
import {createRoot} from "react-dom/client";
import {store} from "./configureStore";
import {registerUnhandledRejectionHandler} from "./global-error-handler";
import {RootComponent} from "./main/components/root/Root.component";
import { BrowserRouter } from "react-router-dom";

import "core-js";
import "./main/utils/polyfill.js";
import "es6-promise/auto";
import "es6-object-assign/auto";
import "react-datepicker/dist/react-datepicker.css";
import "../css/main.scss";

const renderComponent = () => {
    registerUnhandledRejectionHandler();

    const rootElement = document.getElementById("wealth-management");
    const root = createRoot(rootElement!);
    root.render(
        <BrowserRouter>
            <RootComponent store={store}/>
        </BrowserRouter>
    );
};

renderComponent();
